import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface Alert {
  message: string;
  type: 'success' | 'info' | 'warning' | 'danger';
  dismissible: boolean;
  timeout?: number;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alertSubject = new Subject<Alert | null>();

  alert$ = this.alertSubject.asObservable();

  showAlert(
    message: string,
    type: Alert['type'] = 'info',
    dismissible: boolean = true,
    timeout: number = 3000
  ) {
    const alert: Alert = { message, type, dismissible, timeout };
    this.alertSubject.next(alert);

    if (timeout) {
      setTimeout(() => {
        this.clearAlert();
      }, timeout);
    }
  }

  showDanger(message: string, dismissible: boolean = true, timeout?: number) {
    this.showAlert(message, 'danger', dismissible, timeout);
  }

  showSuccess(message: string, dismissible: boolean = true, timeout?: number) {
    this.showAlert(message, 'success', dismissible, timeout);
  }

  clearAlert() {
    this.alertSubject.next(null);
  }
}
